import { TDownloadLaborPosterTemplateRequestSchema } from "./downloadLaborPosterTemplate.schema";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const downloadLaborPosterTemplate = (axios: IAxiosInstance) => {
  return async (ids: TDownloadLaborPosterTemplateRequestSchema) => {
    const response = await axios.noRetry.post<Blob>(
      `/labor-posters/template`,
      ids,
      { responseType: "blob", timeout: 120000 }
    );

    const resData = response.data;

    if (!resData) {
      throw new Error("Failed to download labor poster template");
    }

    return resData;
  };
};
